import React, { useEffect, useState } from 'react'
import {
  IonList,
  IonItemSliding,
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButtons,
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonItemOptions,
  IonItemOption,
} from '@ionic/react'
import { trashOutline, trash, addCircleOutline } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { getEmailDetailsSelector } from '../selectors'
import { deleteEmail, setEmail, setEmailType } from '../../options/store/options.actions'
import { savePatientDemographics, addEmail } from '../store/patientDemographics.actions'
import { IEmailDetail } from '../store/patientDemographics.types'
import SelectButtons from '../../../components/selectButtons/SelectButtons.component'
import { OptionsConstants } from '../../options/store/options.constants'
import Validation from '../../../components/validation/Validation.component'
import { getPatientDemographicsOptionsSelector } from '../../options/selectors'
import { IOption } from '../../../common/common.types'
import { IPHIComponent } from '../../../components/phi/phi.component'
import SInput from '../../../components/stringInput/StringInput.component'

const EmailDetails: React.FC<IPHIComponent> = (props: IPHIComponent) => {
  const { t } = useTranslation()
  const emailDetails = useSelector(getEmailDetailsSelector)
  const patientDemographicsOptions = useSelector(getPatientDemographicsOptionsSelector)
  const { emailTypeOptions } = patientDemographicsOptions
  const dispatch = useDispatch()
  const [flag, setFlag] = useState(true)

  const setEmailAddressOnChange = (e: CustomEvent, emailDetail: IEmailDetail) => {
    e.preventDefault()
    dispatch(setEmail(e.detail.value, emailDetail))
    save()
  }

  const deleteEmailDetail = (emailDetail: IEmailDetail) => {
    dispatch(deleteEmail(emailDetail))
    save()
  }

  const addEmailDetail = () => {
    dispatch(addEmail())
    save()
  }

  const onSelectEmail = (option: IOption | undefined, emailDetail?: IEmailDetail) => {
    if (option && emailDetail) {
      dispatch(setEmailType(option, emailDetail))
      save()
    }
  }

  const save = () => {
    dispatch(savePatientDemographics())
  }

  useEffect(() => {
    if (flag) {
      emailDetails.map((emailDetail: IEmailDetail) => {
        emailDetail.address && dispatch(setEmail(emailDetail.address, emailDetail))
      })
    }
  }, [flag])

  useEffect(() => {
    setFlag(true)

    return () => {
      setFlag(false)
    }
  }, [])

  return (
    <IonList>
      {emailDetails.map((emailDetail: IEmailDetail, index: number) => (
        <IonItemSliding key={emailDetail.key}>
          <IonCard className='ion-no-margin ion-margin-vertical'>
            <IonCardContent>
              <IonGrid className='no-padding'>
                <IonRow>
                  <IonCol>
                    {t('patientDemographics.addressInfo.Email')} {index + 1}
                  </IonCol>
                  <IonButtons>
                    <IonButton data-testid='deleteEmail' onClick={() => deleteEmailDetail(emailDetail)}>
                      <IonIcon icon={trashOutline} />
                    </IonButton>
                  </IonButtons>
                </IonRow>

                <IonRow>
                  <IonCol className='picklist'>
                    <SInput
                      label={t('patientDemographics.addressInfo.Address')}
                      dataTestID={'Address'}
                      inputValue={emailDetail.address}
                      onChangeAction={(e) => {
                        setEmailAddressOnChange(e, emailDetail)
                      }}
                    />
                    <Validation id={OptionsConstants.SET_EMAIL} cardinalityKey={emailDetail.key} />
                  </IonCol>
                </IonRow>

                <hr className='field-divider' />

                <SelectButtons
                  dataTestId='EmailType'
                  options={emailTypeOptions}
                  selectAction={onSelectEmail}
                  selectedID={emailDetail.type}
                  dispatchData={emailDetail}
                  label={t('patientDemographics.addressInfo.Type')}
                />

                <hr className='field-divider' />
              </IonGrid>
            </IonCardContent>
          </IonCard>
          <IonItemOptions side='end' className='delete-swipe'>
            <IonItemOption
              color='danger'
              onDrag={() => deleteEmailDetail(emailDetail)}
              onClick={() => deleteEmailDetail(emailDetail)}>
              <IonIcon slot='icon-only' icon={trash} />
            </IonItemOption>
          </IonItemOptions>
        </IonItemSliding>
      ))}
      <IonRow className='ion-float-right'>
        <IonCol>
          <IonItem lines='none'>
            <IonButton
              data-testid='AddEmail'
              className='transform-none multi-card-add-button'
              fill='clear'
              color='primary-alt'
              onClick={addEmailDetail}>
              <IonIcon icon={addCircleOutline} />
              <IonLabel>{t('patientDemographics.buttons.AddEmail')}</IonLabel>
            </IonButton>
          </IonItem>
        </IonCol>
      </IonRow>
    </IonList>
  )
}

export default EmailDetails
